
<template>
  <v-card>
  <v-container fluid>
  <v-card>
  <form ref="form"
  lazy-validation>
      <v-row align="end"
      style="height: 150px">
          <v-col  cols="12" sm="6" md="3">
          <v-container>
              <template>
              <v-file-input v-model="editedItem.files"
                  ref="fileInput"
                  accept=".xlsx"
                  label="Archivo excel"
                  placeholder="Seleccione su archivo"
                  name="file"  
                  id="file"
              ></v-file-input>
              </template>
          </v-container>
          </v-col>
      </v-row>
      <v-row class="px-4">
      <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="editedItem.Motive" label="Motivo" required></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="editedItem.Commentary" label="Comentario" required></v-text-field>
      </v-col>
      <v-col align-self="center" cols="12" sm="6" md="3">
        <v-btn :disabled="editedItem.files == ''  || editedItem.Motive == ''  || editedItem.Commentary == ''" color="primary" @click="carga">Cargar</v-btn>
      </v-col>
      <v-col align-self="center" cols="12" sm="6" md="3">
        <v-btn color="primary" @click="submit">Buscar Turnos</v-btn>
      </v-col>
      </v-row>
    </form>

    <v-spacer></v-spacer>
    </v-card>
    </v-container>
    <v-container fluid>
      <v-card>
       <v-card-title>
         <v-icon x-large>mdi-clipboard-list-outline</v-icon>Propuestas
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      :items="mvm"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
  
    <template v-slot:item.action="{ item }">
    <v-tooltip bottom>
     <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        class="mr-2"
        v-bind="attrs"
        v-on="on"
        @click="viw_detail(item)"
      >
        mdi-eye
      </v-icon>
      </template>
      <span>Ver Detalle</span>
      </v-tooltip>

      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        class="mr-2"
        v-bind="attrs"
        v-on="on"
        @click="openDialogDeleteItem(item)"
      >
        mdi-delete
      </v-icon>
      </template>
      <span>Eliminar</span>
      </v-tooltip>
    </template>

    <template v-slot:item.Status_id="{ item }">
      <v-chip variant="elevated"
      :color="getChipColor(item.Status_id)"
      label
      >
        {{ item.Status_id }}
      </v-chip>
    </template>
    </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>

    <v-spacer></v-spacer>
    <v-container fluid>
      <v-card>
       <v-card-title>
         <v-icon x-large>mdi-clipboard-list-outline</v-icon>Detalle
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search2"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <template>
        <v-row  v-if="isApprover">
          <v-col class="text-right">
            <v-btn class="ma-2" :disabled="isSelectAllBtnDisabled" @click="checkAllRadios('A')">
              <v-icon color="success">mdi-check-circle</v-icon> Aprobar Todos
            </v-btn>
            <v-btn class="ma-2" :disabled="isSelectAllBtnDisabled" @click="checkAllRadios('C')">
              <v-icon color="error">mdi-delete-circle</v-icon> Cancelar Todos
            </v-btn>
            <v-btn class="ma-2" :disabled="isSelectAllBtnDisabled" @click="checkAllRadios('E')"> 
              <v-icon color="info">mdi-pencil-circle</v-icon> Editar Todos 
            </v-btn>
          </v-col>
        </v-row>
        
      </template>

      <v-data-table
      :headers="headers2"
      :items="mvm_detail"
      :search="search2"
      sort-by="calories"
      class="elevation-1"
    >

      <template v-slot:item.Aprobar="{ item }">
        <td class="text-xs-right">
          <v-radio-group v-model="item.RequestProposalStatus_Cd">
            <v-radio value="A"
            :disabled="item.isCheckboxDisabled"
            @click="radioUpdated($event, item, 'A')"/>
          </v-radio-group>
        </td>
      </template>
      <template v-slot:item.Cancelar="{ item }">
        <td class="text-xs-right">
            <v-radio-group v-model="item.RequestProposalStatus_Cd">
              <v-radio value="C"
              :disabled="item.isCheckboxDisabled"
              @click="radioUpdated($event, item, 'C')"/>
            </v-radio-group>
          </td>
      </template>
      <template v-slot:item.Editar="{ item }">
        <td class="text-xs-right">
            <v-radio-group v-model="item.RequestProposalStatus_Cd">
              <v-radio value="E"
              :disabled="item.isCheckboxDisabled"
              @click="radioUpdated($event, item, 'E')"/>
            </v-radio-group>
          </td>
      </template>
    </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>
  <template>
  <div class="text-center d-flex justify-space-around">
      <v-btn v-if="isApprover" type="button" :disabled="isApplyChangesBtnDisabled" color="primary" @click="submitChanges" class="mx-2 mb-2">Aplicar Cambios</v-btn>
      <v-btn type="button" color="primary" @click="onexport" class="mx-4">Descargar Detalle</v-btn>
    </div>
  
  </template>
    <v-dialog v-model="dialog_new" max-width="900px">
    <v-stepper v-model="e1" vertical>
           <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
          <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
              <small>{{this.step_txt2}}</small>
          </v-stepper-step>
          <v-stepper-content step="1">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>  
      </v-stepper>
    </v-dialog>

    <v-dialog v-model="dialog_new_apply" max-width="900px" persistent>
    <div>
      <v-stepper :model-value="e1">
        <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
        <v-stepper-header>
          <v-stepper-step
            step="1"
            :complete="e1 > 1"
          >Guardando cambios</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step 
          step="2"
          :complete="e1 > 2"
          >Aplicando Cambios
          <small>Modificando datos en tablas</small>
      </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step 
          step="3"
          :complete="e1 > 3"
          > Enviando mails</v-stepper-step>
        </v-stepper-header>
        <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
      </v-stepper>
    </div>
    </v-dialog>
    <v-dialog v-model="dialog_load" max-width="400" persistent>
      <v-card color="blue-grey darken-3" dark>
        <div v-if="!invalidHeaders">
          <v-card-title class="headline">Cantidad de Filas Procesadas</v-card-title>
          <v-card-text class="text-h6" style="padding-bottom:0; padding-top:0;">Correctas: {{ rowsOk }}</v-card-text>
          <v-card-text class="text-h6" style="padding-bottom:0; padding-top:0;">Formato incorrecto: {{ rowsBadFormat }}</v-card-text>
          <div v-if="rowErrors && rowErrors.length > 0">
            <v-list style="max-height: 200px; overflow-y: auto;" class="blue-grey darken-3">
              <v-list-item v-for="error in rowErrors" :key="error.line">
                <v-list-item-content>
                  <v-list-item-title style="color: red;">
                    Línea {{ error.line }}: {{ error.errors }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <v-card-text class="text-h6" style="padding-bottom:4; padding-top:0;">Omitidas: {{ rowsOmmited }}</v-card-text>
          <div v-if="noRows">
            <v-card-subtitle>No hay filas para procesar</v-card-subtitle>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn>
            </v-card-actions>
          </div>
          <div v-if="!noRows">
            <div style="display:flex; justify-content:center" v-if="!processComplete">
              <v-progress-circular model-value="20" indeterminate class="mx-2"></v-progress-circular><span>Aguarde mientras se procesa la solicitud</span>
            </div>
            <div style="display: flex; justify-content: center; max-height: 200px; overflow-y: auto;" v-else-if="processComplete">
              <v-card-text :style="{ color: textColorMsj }" class="text-h6">{{ msjError }}</v-card-text>
            </div>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog_load=false" :disabled="!processComplete">Cerrar</v-btn>
            </v-card-actions>
          </div>
        </div>
        <div v-else-if="invalidHeaders">
          <v-card-subtitle>Las cabeceras del archivo no concuerdan con los esperados.</v-card-subtitle>
          <v-card-actions>
          <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn>
          </v-card-actions>
        </div>
        

      </v-card>
    </v-dialog>

        <!-- Pop up borrar -->
        <v-dialog v-model="dialog_delete" max-width="350">
          <v-card class="px-2 py-2">
            <v-card-title class="headline mb-3"> ¿Desea borrar propuesta?</v-card-title>
            <div v-if="overlay" class="d-flex justify-center mb-2">
              <v-progress-circular  indeterminate  :size="50"></v-progress-circular>
            </div>
            <v-spacer></v-spacer>

            <v-card-actions>
            <v-spacer></v-spacer>
          <div>
            <v-btn color="primary" @click="close">Volver</v-btn>
            <v-btn color="error" @click="deleteRegistry" >Borrar</v-btn>
          </div>
                
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-card>


  </template>

  
  <script>
  import axios from 'axios'
  //import Vue from "vue";
  //import JsonExcel from "vue-json-excel";
  import XLSX from 'xlsx';
   
  //Vue.component("downloadExcel", JsonExcel);
  
  export default {
    data: () => ({
      
      dialog_load: false,
      rowsOmmited: 0,
      rowsBadFormat: 0,
      rowsOk: 0,
      noRows: false,
      processComplete: false,
      invalidHeaders: false,
      textColorMsj: "white",
      msjError: "",
      search: '',
      search2: '',
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      dialog: false,
      dialog_pass: false,
      dialog_new: false,
      dialog_new_apply: false,
      dialog_detail: false,
      dialog_delete:false,
      valid: true,
      menu: false,
      menu2: false,
      e1: 0,
      btnap:true,
      btn: false,
      msj_proceso:'',
      progressBar1: false,
      progressBar: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      RequestProposal_id:'',
      step_txt1:'',
      step_txt2:'',
      TurningStorageArea_id:'',
      TurningStorageArea_Desc:'',
      OpPoint_id: '',
      Supplier_Description:'',
      VendorPurchaseOrder_Num:'',
      Section_id:'',
      LastOpRepUser_id: '',
      RepEvent_Dttm: '',
      ApiUser_GivenName:'',
      status:'',
      CDay_id:'',
      CHour_Description:'',
      id_process:'',
      isApprover: false,
      ApiUserSupplier: [],
      currentProposalId: '',
      rowErrors: [],
      deleteIndex:'',

      headers: [
        { text: 'Actions', value: 'action', sortable: false },
        // { text: 'Id', value: 'ProposalTurnUpdate_id' }, 
        { text: 'Prov', value: 'MotherSupplier_id' },  
        { text: 'R Social', value: 'MotherSupplier_desc' },
        { text: 'Motivo', value: 'Internal_Note' },
        { text: 'Comentario', value: 'Comment_Txt' },
        { text: 'Prioridad', value: 'Priority_id' },
        { text: 'Status', value: 'Status_id' } ,
        { text: 'Fecha Hora Carga', value: 'RepEvent_Dt' }  
      ],
      headers2:[
        { text: 'Propuesta Pedido id', value: 'RequestProposal_id' },  
        { text: 'OC', value: 'VendorPurchaseOrder_Num' },
        { text: 'Punto', value: 'OpPoint_id' },
        { text: 'Fecha de turno', value: 'OrigCDay_id' },
        { text: 'Fecha de Cambio', value: 'CDay_id' },
        { text: 'Hora de Cambio', value: 'CHour_id' },
        { text: 'Fecha Emisión', value: 'RequestProposal_Dt'},
        { text: 'Fecha de cierre', value: 'Closing_Dt' },
        { text: 'Almacen', value: 'TurningStorageArea_id' },
        { text: 'Bultos pedidos', value: 'RequestPack_Qty' }  ,
        { text: 'Pallets Pedidos', value: 'RequestPallet_Qty' } ,
        { text: 'Indicador', value: 'Type_ind' } ,
        { text: 'Error', value: 'ReplicationError'},
        { text: 'Error Desc', value: 'ReplicationError_desc'},
        // { text: 'RequestProposalStatus_Cd', value: 'RequestProposalStatus_Cd'},
      ],
      mvm: [],
      mvm_detail: [],
      mvm_detail_auto_approve: [],
      mvm_detail_auto_indexes: [],

      editedIndex: -1,
      editedItem: {
        fecha: new Date().toISOString().substr(0, 10),
        files: [],
        Motive: '',
        Commentary: ''
      },
      
      fechaRule: [
          v => !!v || 'Fecha es requerida'
      ],
      datoRule: [
          v => !!v || 'El dato es Requerido'
         
      ],
      
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
  
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
      },
      isApplyChangesBtnDisabled(){
        if (this.mvm_detail.length === 0) return true;

        let status = this.mvm_detail.map(detail => detail.RequestProposalStatus_Cd);

        let hasEmptyStatus = status.some(s => s === '' || s === null || s === undefined);

        let allPreviouslyEvaluated = this.mvm_detail.every(
          detail => detail.ReplicationError_desc === 'Turno previamente evaluado.'
        );

        if (hasEmptyStatus || allPreviouslyEvaluated) {
          return true;
        } else {
          return false;
        }
      },

      isSelectAllBtnDisabled(){
        return this.mvm_detail.length != 0 ? false : true 
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
  
    created () {
      this.initialize()
    },
  
    methods: {

      initialize () {
        axios.post(this.api_tool_url + '/get_roleuser', {ApiUser_id: sessionStorage.getItem('ApiUser_id')}, this.config)
          .then(response => {
              let roles = response.data.ResultRows
              if(roles.find(role => role.ApiRole_id == 'administrator')){
                this.isApprover = true
                this.headers2.push({ text: 'Aprobar', value: 'Aprobar'});
                this.headers2.push({ text: 'Cancelar', value: 'Cancelar'});
                this.headers2.push({ text: 'Editar', value: 'Editar'});
              }
          })
          .catch(error => {
            alert(error.response.data.message)
          }),
        
        axios.post(this.api_tool_url + '/get_ApiUserSupplier', {ApiUser_id:this.$store.state.ApiUser_id}, this.config)
          .then(response => { 
              response.data.ResultRows.forEach(info => {
              this.ApiUserSupplier.push(info.MotherSupplier_Desc)
              })
          })
          .catch(error => {
            this.ApiUserSupplier = []
            alert(error.response.data.message)
        })
        
      },

      carga() {
        this.btn = true
        this.btnap=true

        this.noRows = false;
        this.invalidHeaders = false;
        this.processComplete = false;
        this.dialog_load = false;

        //this.step_txt1="Carga de archivo"
        //this.step_txt2="Cargando"
        //this.dialog_new = true
        //this.e1 = 1
        //this.progressBar = true
        //this.step_error1 = true
        //this.step_error2 = true
        //this.step_error3 = true
        
        //this.step_color1 = "primary",
        //this.step_color2 = "primary",
        //this.step_color3 = "primary",
        //this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        let filter = new FormData();
        this.mvm = []
        let file = this.editedItem.files;
        if (file) 
        {
          const reader = new FileReader();
          reader.onload = (e) => 
            {
              this.dialog_load = true;
              const bstr = e.target.result;
              const wb = XLSX.read(bstr, { type: 'binary' });
              const wsname = wb.SheetNames[0];
              const ws = wb.Sheets[wsname];
              let data = XLSX.utils.sheet_to_json(ws, { header: 1 });

              data = data.filter(subArr => subArr.length > 0);

              if (data.length <= 1) {
                  this.noRows = true;
                  this.overlay = false;
                  return;
              }

              let headers = data[0];
              const requiredHeaders = ['Punto_Operacional_Id', 'Orden_Compra_Num', 'Fecha_Turno', 'Hora_Turno', 'Tipo_Movimiento'];
              let validHeaders = requiredHeaders.every(header => headers.includes(header));

              if (!validHeaders) {
                  this.invalidHeaders = true;
                  this.overlay = false;
                  return;
              }

              let cantOmitidos = 0;
              let cantFormatoError = 0;
              let cantOk = 0;
              let rowsComplete = [];
              let errors = [];

              let idxOppoint = headers.indexOf('Punto_Operacional_Id');
              let idxFechaTurno = headers.indexOf('Fecha_Turno');
              let idxHoraTurno = headers.indexOf('Hora_Turno');

              let regExpLetras = /[a-zA-Z]/g;
              let regExpFecha = /^\d{4}-\d{2}-\d{2}$/;

              data.forEach((row, index) => {
                  if (index === 0) return; // Saltar cabecera

                  const opPointValue = row[idxOppoint];
                  const fechaTurnoValue = row[idxFechaTurno];
                  const horaTurnoValue = row[idxHoraTurno];

                  let errorMessages = [];

                  if (
                      opPointValue === undefined || opPointValue === null || opPointValue === '' ||
                      fechaTurnoValue === undefined || fechaTurnoValue === null || fechaTurnoValue === '' ||
                      horaTurnoValue === undefined || horaTurnoValue === null || horaTurnoValue === ''
                  ) {
                      cantOmitidos += 1;
                  } else if (
                      regExpLetras.test(opPointValue.toString()) ||               
                      isNaN(Number(horaTurnoValue)) ||                            
                      !regExpFecha.test(fechaTurnoValue.toString())
                  ) {
                      cantFormatoError += 1;

                      if (regExpLetras.test(opPointValue.toString())) {
                          errorMessages.push("Punto_Operacional_Id contiene letras.");
                      }
                      else if (isNaN(Number(horaTurnoValue))) {
                          errorMessages.push("Hora_Turno no es numérico.");
                      }
                      else if (!regExpFecha.test(fechaTurnoValue.toString())) {
                          errorMessages.push("Fecha_Turno no cumple el formato.");
                      }
                      else
                      {
                          errorMessages.push("Revisar.");
                      }

                      errors.push({
                          line: index + 1, // Líneas en Excel comienzan desde 1
                          errors: errorMessages.join(" ")
                      });
                  } else {
                      cantOk += 1;
                      rowsComplete.push(row);
                  }
              });

              this.rowsOmmited = cantOmitidos;
              this.rowsBadFormat = cantFormatoError;
              this.rowsOk = cantOk;
              this.rowErrors = errors;

              filter.append('foo', 'bar');
              filter.append('file', document.getElementById('file').files[0]);
              filter.append('email', sessionStorage.getItem('ApiUser_EMail'));
              filter.append('user', sessionStorage.getItem('ApiUser_id'));
              filter.append('token',sessionStorage.getItem('access_token'))
              filter.append('motive', this.editedItem.Motive)
              filter.append('commentary', this.editedItem.Commentary)


              axios.post(this.api_tool_url + '/fileUpload_Modif', filter, this.config)
              .then(response => {
                      if(response.data.status == "OK"){
                        // console.log('Aqui en mvm')
                        this.mvm = response.data.ResultRows
                        this.id_process = response.data.Proceso_id 
                        this.btnap=false
                        //this.e1 = 1
                        //this.step_color1 = "#008000"
                        //this.progressBar = false
                        //this.msj_proceso = 'Se realizo la carga correctamente.'
                        this.btn = false
                        this.active = false  
                        this.editedItem.files = []
                        
                        this.msjError = 'Propuesta cargada correctamente.';
                        this.textColorMsj = this.msjError ? "white" : "";
                        
                        this.processComplete = true;
                        this.overlay = false;
                        setTimeout(() => {
                          this.dialog_load = false;
                        }, 5000);
                      }else {
                          //this.e1 = 1
                          //this.step_color1 = "#C0392B"
                          //this.progressBar = false
                          //this.msj_proceso = response.data.Msg
                          this.msjError = response.data.Msg + " -> " + JSON.stringify(response.data.ResultRows);
                          this.textColorMsj = this.msjError ? "red" : "";
                          this.processComplete = true;
                          // console.log(response.data.ResultRows)
                          //this.msj_proceso += '\n'
                          //this.msj_proceso += JSON.stringify(response.data.ResultRows)
                          this.mvm = [] 
                          this.btn = false
                          this.active = true
                          this.editedItem.files = []
                          this.$refs.fileInput.reset();
                      }
                      this.btn = false  
                  })
                  .catch(error => {
                      this.btn = false
                      //this.step_error1 = false
                      //this.progressBar = false
                      //this.msj_proceso = error.response.data.message
                      this.msjError = error.response.data;
                      this.textColorMsj = this.msjError ? "red" : "";
                      this.processComplete = true;
                      this.active = true
                      this.editedItem.files = []
                      //console.log(this.editedItem)
                      // console.log('Aqui en el error!!')
                      this.$refs.fileInput.reset();
                  })
              
                this.editedItem = {
                  fecha: new Date().toISOString().substr(0, 10),
                  files: [],
                  Motive: '',
                  Commentary: ''
                  }

                // console.log(this.editedItem)
                // console.log('Fuera del catch en el error!!')
                this.$refs.fileInput.reset();

            };
            reader.readAsBinaryString(file);
        }
      },
      
  
      close () {
        this.dialog_new = false
        this.dialog_new_apply = false
        this.dialog_delete = false
      },
      close2 () {
        this.dialog_detail= false
      },
      submitChanges(){
        this.e1 = 1
        this.dialog_new_apply = true;
        this.progressBar = true
        this.msj_proceso = "Guardando modificaciones."
        // console.log('Aplicar cambios')
        // console.log(this.mvm_detail)
        let filter = null
        let filteredDetails = this.mvm_detail.filter(item => !item.isCheckboxDisabled)
        filter = {Details:filteredDetails , email: this.$store.state.ApiUser_EMail}
        axios.post(this.api_tool_url + '/save_proposalTurnLineUpdate',filter, this.config)
        .then(response => {
          if(response.data.ResultRows.length >= 1)
          {
            this.e1= 2
            this.msj_proceso = "Persistiendo cambios en tablas."
            let data={ApiUser_id:sessionStorage.getItem('ApiUser_id'), token:sessionStorage.getItem('access_token')}

            axios.post(this.api_tool_url + '/ApplyChanges_modif', data, this.config)
                .then(response => {
                    if(response.data.ResultRows.length >= 1)
                    {
                      this.e1=3
                      this.msj_proceso = "Enviando mail a proveedor con los cambios."

                      axios.post(this.api_tool_url + '/send_proposalTurnUpdates', filter, this.config)
                        .then(response => {
                            if(response.data.ResultRows.length >= 1)
                            {
                              this.e1=4
                              this.progressBar = false
                              this.msj_proceso = "Mails Enviados exitosamente."
                              let ProposalTurnUpdate_id = filteredDetails[0]["ProposalTurnUpdate_id"]
                            
                              axios.post(this.api_tool_url + '/upd_proposalModif', {ProposalTurnUpdate_id: ProposalTurnUpdate_id}, this.config)
                                .then(response => {
                                  setTimeout(this.close, 3000)
                                })
                              
                            }
                            else{
                                this.step_error1 = true
                                this.progressBar = false
                                this.msj_proceso = "No se pudo enviar mail."
                            }
                        })
                        .catch(error => {
                            this.step_error1 = true
                            this.progressBar = false
                            this.msj_proceso = error.response.data.message
                        })
                    }
                    else{
                        this.step_error1 = true
                        this.progressBar = false
                        this.msj_proceso = "No se pudieron aplicar los cambios."
                    }
                })
                .catch(error => {
                    this.step_error1 = true
                    this.progressBar = false
                    this.msj_proceso = error.response.data.message
                })
          }
          else{
              this.step_error1 = true
              this.progressBar = false
              this.msj_proceso = "Error al guardar."
          }
        })
        .catch(error => {
          this.step_error1 = true
          this.progressBar = false
          this.msj_proceso = error.response.data.message
        })
      }, 

      submit(){
      this.step_txt1="Buscando OCs"
      this.step_txt2="Consultando"
      this.dialog_new = true
      this.e1 = 1
      this.progressBar = true
      this.step_error1 = true
      this.step_error2 = true
      this.step_error3 = true
      this.step_color1 = "primary",
      this.step_color2 = "primary",
      this.step_color3 = "primary",
      this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
      this.mvm = []
      this.mvm_detail = []
      let filter = null
      filter = {Supplier:this.ApiUserSupplier}
      axios.post(this.api_tool_url + '/get_planning_modif',filter, this.config)
          .then(response => {

            if(response.data.ResultRows.length >= 1)
            {
                this.id_process = response.data.Proceso_id 
                // console.log(response.data.ResultRows)
                this.mvm = response.data.ResultRows
                this.e1 = 1
                this.step_color1 = "#008000"
                this.msj_proceso = "Propuestas cargadas."
                this.active = false
                this.progressBar = false
                setTimeout(this.close, 3000)
            }
            else{
                this.progressBar = false
                this.msj_proceso = "No se encontraron turnos."
                this.step_error1 = false
                this.step_error2 = false
                this.step_error3 = false
            }
            this.btn = false
          })
          .catch(error => {
            this.mvm = []
            this.btn = false
            this.step_error1 = false
            this.progressBar = false
            this.msj_proceso = error.response.data.message
          })
      },

      viw_detail(item){
        this.step_txt1="Buscando detalles"
        this.step_txt2="Consultando"
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        this.mvm_detail = []
        // console.log(item["ProposalTurnUpdate_id"])
        let filter = {ProposalTurnUpdate_id : item["ProposalTurnUpdate_id"]}
        this.currentProposalId = item["ProposalTurnUpdate_id"]
        // console.log(filter)
        axios.post(this.api_tool_url + '/get_planning_modif_detail', filter, this.config)
                .then(async response => {
                   // console.log(response.data.ResultRows)
                    if(response.data.ResultRows.length == 1)
                    {
                      this.mvm_detail = response.data.ResultRows
                      // Pre completar el aprobado para turnos que lo requieran
                      for (let i = 0; i < this.mvm_detail.length; i++) 
                      {
                        this.getAvailableTurns({ ResultRows: this.mvm_detail[i] },item["Status_id"]);
                      }
                      this.e1 = 1
                      this.step_color1 = "#008000"
                      this.msj_proceso = "Detalles cargados."
                      this.active = false
                      this.progressBar = false
                      setTimeout(this.close, 3000)
                    }else if(response.data.ResultRows.length > 1){

                      // Me armo un array de todos los registros que no fueron evaluados aún.
                      let arrToEvaluate = [];

                      this.mvm_detail = response.data.ResultRows.map(item => {
                        let status = item.RequestProposalStatus_Cd;
                        let isEmptyStatus = !status;

                        if (isEmptyStatus) {
                          arrToEvaluate.push({
                            ProposalTurnUpdate_id: item.ProposalTurnUpdate_id,
                            RequestProposal_id: item.RequestProposal_id
                          });
                        }

                        // Si ya fue evaluado dejo la descripción 'Turno evaluado' y lo marco
                        // Si aún no fue evaluado le dejo 'Calculando capacidad'
                        return {
                          ...item,
                          ReplicationError_desc: isEmptyStatus ? 'Calculando capacidad...' : 'Turno previamente evaluado.',
                          ...(isEmptyStatus ? {} : { isCheckboxDisabled: true })
                        };
                      });

                      if (arrToEvaluate.length > 0) {
                        let uniqueId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
                        let filt = { ProposalTurnUpdate_id : item["ProposalTurnUpdate_id"], uniqueId: uniqueId };
                        await this.evaluateBatch(filt);

                        // Limpiar registros que quedaron con "Calculando capacidad..." sin cambios
                        this.mvm_detail.forEach((detail, index) => {
                          if (detail.ReplicationError_desc === 'Calculando capacidad...') {
                            this.$set(this.mvm_detail, index, {
                              ...detail,
                              ReplicationError_desc: ''
                            });
                          }
                        });
                      }
                      
                      this.e1 = 1
                      this.step_color1 = "#008000"
                      this.msj_proceso = "Detalles cargados."
                      this.active = false
                      this.progressBar = false
                      setTimeout(this.close, 3000)
                    }else{
                        this.progressBar = false
                        this.msj_proceso = "No se encontro detalle."
                        this.step_error1 = false
                        this.step_error2 = false
                        this.step_error3 = false
                    }
                })
                .catch(error => {
                    this.mvm_detail = []
                    this.step_error1 = false
                    this.step_error2 = false
                    this.step_error3 = false
                    this.progressBar = false
                    this.msj_proceso = error.response.data.message
                })
      },

      async evaluateBatch(filt) {
        try {
          // Insertar en tabla intermedia
          await axios.post(this.api_tool_url + "/upload_intermed_modif", filt, this.config);

          // Verificar si hay propuestas cerradas o eliminadas
          await this.checkProposals(filt);

          // Validar fechas (fecha de cierre vs fecha propuesta)
          this.checkValidDates();

          // Validar fechas por disponibilidad de horarios
          let validDateIDs = await this.checkValidDateTurn(filt);

          let invalidDateIndices = this.mvm_detail
            .map((detail, index) => (!validDateIDs.includes(detail.RequestProposal_id) ? index : null))
            .filter(index => index !== null);

          // Si no tienen horarios válidos sale
          // if (invalidDateIndices.length > 0) {
            // Comento para que no quede la descripción.
            //this.updateReplicationDesc(invalidDateIndices, 'No hay horarios válidos disponibles.');
            // if (invalidDateIndices.length === this.mvm_detail.length) return;
          // }
          

          // Validar capacidad para los que tienen fecha válida
          let validCapacityIDs = await this.checkValidCapacity(filt);

          let invalidCapacityIndices = this.mvm_detail
            .map((detail, index) =>
              validDateIDs.includes(detail.RequestProposal_id) &&
              !validCapacityIDs.includes(detail.RequestProposal_id) ? index : null
            )
            .filter(index => index !== null);

          // Si no hay capacidad sale
          //if (invalidCapacityIndices.length > 0) {
            // Comento para que no quede la descripción.
            // this.updateReplicationDesc(invalidCapacityIndices, 'No hay capacidad disponible.');
            //if (validCapacityIDs.length === 0) return;
          //}

          // Si hay al menos uno válido, guardar, aplicar y enviar mail
          if (this.mvm_detail_auto_approve.length > 0) {
            await this.saveProposalMult();
          }

          // Limpiar registros que quedaron con "Calculando capacidad..." sin cambios
          this.mvm_detail.forEach((detail, index) => {
            if (detail.ReplicationError_desc === 'Calculando capacidad...') {
              this.$set(this.mvm_detail, index, {
                ...detail,
                ReplicationError_desc: ''
              });
            }
          });

        } catch (error) {
          console.error('Error en evaluación batch:', error);
          if(error.response.data.message){
            alert(error.response.data.message)
          }else{
            alert(error.message)
          }
        }
      },

      /** Evalua si la propuesta existe en RequestProposal
      **  Si existe verifica que tenga un estado que no sea cerrado.
      */
      async checkProposals(filt){
        //Chequear el estado de la propuesta
        let responseStatus = await axios.post(this.api_tool_url + '/get_requestproposalmultiple', filt, this.config);
        let proposalReg = responseStatus.data.ResultRows
        
        if (proposalReg){
          for (let item of proposalReg) {
            let { RequestProposal_id, RequestProposalStatus_Cd} = item;
            if (['E', 'F', 'X'].includes(RequestProposalStatus_Cd)) {
              let index = this.mvm_detail.findIndex(
                detail => detail.RequestProposal_id === RequestProposal_id
              );

              if (index !== -1) {
                let detail = this.mvm_detail[index];
                this.radioUpdated(null, detail, 'C');
                this.$set(this.mvm_detail, index, {
                  ...detail,
                  ReplicationError_desc: 'La orden está cerrada o eliminada',
                  ReplicationError: 'E',
                  isCheckboxDisabled: true
                });
              }
            }
          }
        }
      },
      
      /** Evalua si la propuesta tiene fechas válidas
      */
      checkValidDates(){
        this.mvm_detail.map((detail,index) =>{
          if ((detail.CDay_id <= detail.Closing_Dt) === false || (detail.CDay_id >= detail.RequestProposal_Dt) === false)
          //if ((detail.CDay_id >= detail.Closing_Dt) === false || (detail.CDay_id <= detail.RequestProposal_Dt) === false)
          {
            this.radioUpdated(null, detail, 'C');
            this.mvm_detail[index].ReplicationError_desc = 'La nueva fecha es mayor a la fecha cierre.'
            this.mvm_detail[index].ReplicationError = 'E'
          }
        })
      },

      /** Evalua si la propuesta tiene horario para poder guardar
      */
      async checkValidDateTurn(filt) {
        let response = await axios.post(this.api_tool_url + '/get_chourmultiple', filt, this.config);
        let availableTurns = response.data.ResultRows;
        return availableTurns ? availableTurns.map(item => item.RequestProposal_id) : [];
      },

      /** Evalua si la propuesta tiene capacidad para poder guardar
      */
      async checkValidCapacity(filt) {
        let response = await axios.post(this.api_tool_url + '/get_effectiveturncapacitymultiple', filt, this.config);
        let availableTurns = response.data.ResultRows;

        this.mvm_detail_auto_approve = [];
        this.mvm_detail_auto_indexes = [];

        if (!availableTurns || availableTurns.length === 0) return [];

        let validIDs = [];

        for (let item of availableTurns) {
          let { RequestProposal_id } = item
          let index = this.mvm_detail.findIndex(d => d.RequestProposal_id === RequestProposal_id)

          if (index !== -1) {
            let detail = this.mvm_detail[index]

            // Solo continuar si el turno NO fue evaluado
            let status = detail.RequestProposalStatus_Cd
            let isEmptyStatus = false
            if(status === null || status === undefined || status === ''){
              isEmptyStatus = true
            }
            if (!isEmptyStatus) {
              return; // lo salteamos
            }

            this.mvm_detail_auto_approve.push(detail);
            this.mvm_detail_auto_indexes.push(index);
            validIDs.push(RequestProposal_id);

            this.radioUpdated(null, detail, 'A');
            this.$set(this.mvm_detail, index, {
              ...detail,
              ReplicationError_desc: 'Hay capacidad disponible para el punto, dia, hora y almacen a turnar.',
              ReplicationError: 'W',
              isCheckboxDisabled: true
            });
          }
        }

        return validIDs;
      },

      /** Cambia la descripción y marca el registro para no ser tomado en Aplicar Cambios.
      */
      updateReplicationDesc(indices, text) {
        indices.forEach(index => {
          if (this.mvm_detail[index]) {
            this.$set(this.mvm_detail, index, {
              ...this.mvm_detail[index],
              ReplicationError_desc: text,
              isCheckboxDisabled: true
            });
          }
        });
      },

      /** Guarda el registro en save_proposalTurnLineUpdate
       * Aplica los cambios
       * Genera los mails
      */
      async saveProposalMult(){
        try{

          let filter = {Details:this.mvm_detail_auto_approve, email: this.$store.state.ApiUser_EMail}
          // console.log('Filter dentro de saveProposalMult', filter)
          // Cambio el estado a Aprobado y modifico el turno
          let responseSave = await axios.post(this.api_tool_url + '/save_proposalTurnLineUpdate', filter, this.config);
          if(responseSave){
            // console.log('Filter dentro de if de ResponseSave', responseSave)
            this.updateReplicationDesc(this.mvm_detail_auto_indexes, 'Hay capacidad disponible (Aplicando cambios en el turno...).')
            let data={ApiUser_id:sessionStorage.getItem('ApiUser_id'), token:sessionStorage.getItem('access_token')}
            // console.log(data)
            let responseApply = await axios.post(this.api_tool_url + '/ApplyChanges_modif', data, this.config);
            if(responseApply){
              // console.log('Filter dentro de if de responseApply', responseApply)
              this.updateReplicationDesc(this.mvm_detail_auto_indexes, 'Hay capacidad disponible (Enviando mail a proveedor con los cambios...).')
              let responseSendMail = await axios.post(this.api_tool_url + '/send_proposalTurnUpdates', filter, this.config)
              if(responseSendMail){
                // console.log('Filter dentro de if de responseSendMail', responseSendMail)
                this.updateReplicationDesc(this.mvm_detail_auto_indexes, 'Capacidad disponible. Turno aplicado correctamente.')
              }else{
                this.updateReplicationDesc(this.mvm_detail_auto_indexes, 'No se pudo enviar mail en el turno automaticamente')
              }
            }else{
              this.updateReplicationDesc(this.mvm_detail_auto_indexes, 'Se produjo un error en el cambio del turno automaticamente. Hay capacidad disponible.')
            }
          }else{
            this.updateReplicationDesc(this.mvm_detail_auto_indexes, 'Hay capacidad disponible. No se pudieron aplicar los cambios en el turno automaticamente.')
          }
          let valid = false;
          // Verificar si hay turnos disponibles
          if (responseSave){
            valid = true;
          }
          return valid;
        }catch(error){
          alert(error)
          return false
        }
      },

      openDialogDeleteItem (item) {
          this.dialog_delete = true
          this.deleteIndex = this.mvm.indexOf(item)
          //console.log(this.deleteIndex)
          //confirm('Are you sure you want to delete this item?') && this.deleteSustitucion(index)
      },

      deleteRegistry() {
        this.overlay = true

        let tmpObj = this.mvm[this.deleteIndex]
        let tpm = {
          ProposalTurnUpdate_id: tmpObj.ProposalTurnUpdate_id,
          MotherSupplier_id: tmpObj.MotherSupplier_id
        }
        //console.log(tpm)
        
        axios.post(this.api_tool_url + "/del_planning_modif", tpm, this.config)
        .then(response => {
          //this.items.splice(this.deleteIndex, 1)
          this.mvm = []
          this.overlay = false
          this.close()

        })
        .catch(error => {
            this.mvm = []
            this.overlay = false
            alert(error.response.data.message)
        })
      },
      
      async getAvailableTurns(data,status) {
          // Verificar si la data de entrada es valida y asignar a una constante.
          if (!data || !data.ResultRows || data.ResultRows.length === 0)
          {
              console.error('No se puede autocompletar la aprobación para alguno de los detalles.');
              return;
          }

          const { CDay_id, OpPoint_id, TurningStorageArea_id, RequestPallet_Qty, RequestPack_Qty, CHour_id, RequestProposal_Dt, Closing_Dt, RequestProposal_id } = data.ResultRows;
          const detail = data.ResultRows;
          const index = this.mvm_detail.indexOf(detail)
          
          //Filtro para chequear el estado de la propuesta
          const filterStatus = {
                  RequestProposal_id: RequestProposal_id
              };

          //Chequear el estado de la propuesta
          const responseStatus = await axios.post(this.api_tool_url + '/get_requestproposal', filterStatus, this.config);
          const proposalReg = responseStatus.data.ResultRows
          if (proposalReg && proposalReg.length > 0) 
          {
            if (['E', 'F', 'X'].includes(proposalReg[0].RequestProposalStatus_Cd)) 
            {
              this.radioUpdated(null, detail, 'C');
              this.$set(this.mvm_detail, index, {
                ...this.mvm_detail[index],
                ReplicationError_desc: 'La orden está cerrada o eliminada',
                ReplicationError: 'E',
                isCheckboxDisabled: true
              });
              return;
            }
          }

          if(status != 'REVISADO')
          {
            try 
            {
                //let fechaActual = new Date();
                //let fechaTurno = new Date(CDay_id) 
                this.mvm_detail[index].ReplicationError_desc = 'Calculando capacidad...'

                if ((CDay_id <= Closing_Dt) === false || (CDay_id >= RequestProposal_Dt) === false)
                {
                    this.radioUpdated(null, detail, 'C');
                    this.mvm_detail[index].ReplicationError_desc = 'La nueva fecha es mayor a la fecha cierre.'
                    this.mvm_detail[index].ReplicationError = 'E'
                    return;
                }
                
                // Comentado por error 502
                /*
                else if (fechaTurno < fechaActual){
                  this.radioUpdated(null, detail, 'C');
                    this.mvm_detail[index].ReplicationError_desc = 'Fecha de turno anterior al día actual.'
                    this.mvm_detail[index].ReplicationError = 'E'
                    return;
                }
                */


                // Preparar un filtro para encontrar un turno valido en el dia, tienda y almacen.
                const filterTurns = {
                    CDay_id: CDay_id,
                    OpPoint_id: OpPoint_id,
                    TurningStorageArea_id: TurningStorageArea_id
                };

                // Llamada al endpoint para traer toda la posibilidad de horarios para la fecha, tienda y almacen.
                const responseTurns = await axios.post(this.api_tool_url + '/get_chour', filterTurns, this.config);
                const availableTurns = responseTurns.data.ResultRows;

                // Verificar si hay turnos disponibles
                if (!availableTurns || availableTurns.length === 0) 
                {
                    this.$set(this.mvm_detail, index, {
                        ...this.mvm_detail[index],
                        ReplicationError_desc: ''
                    });
                    return;
                }

                // Verificar si coincide algun turno con la hora necesaria del cambio.
                const validTurn = availableTurns.find(turn => turn.CHour_id === CHour_id);

                if (!validTurn) 
                {
                    // No se encontro un turno valido con la hora especificada.
                    this.$set(this.mvm_detail, index, {
                        ...this.mvm_detail[index],
                        ReplicationError_desc: ''
                    });
                    return;
                }

                // Preparar un filtro para buscar si hay capacidad disponible para ese dia, hora, tienda y alamacen.
                const filterCapacity = {
                    CDay_id: validTurn.CDay_id,
                    CHour_id: validTurn.CHour_id,
                    OpPoint_id: validTurn.OpPoint_id,
                    TurningStorageArea_id: validTurn.TurningStorageArea_id
                };

                // Llamar al endpoint para verificar la capacidad.
                const responseCapacity = await axios.post(this.api_tool_url + '/get_effectiveturncapacity', filterCapacity, this.config);

                // Si hay datos de capacidad en la respuesta del endpoint.
                if (responseCapacity.data && responseCapacity.data.ResultRows) 
                {
                    const capacities = responseCapacity.data.ResultRows;
                    const matchingCapacity = capacities.find(cap => 
                        ((cap.HandlingCapacity_Cnt + cap.ToleratedHandlingCapacity_Cnt) - cap.OccupiedItemCapacity_Cnt) >= (RequestPallet_Qty + RequestPack_Qty) 
                    );

                    if (matchingCapacity) 
                    {
                        // Se encontro un turno con capacidad suficiente
                        /*alert(`Turno disponible: 
                            Dia: ${validTurn.CDay_id} 
                            Hora: ${validTurn.CHour_Description}
                            Almacen: ${validTurn.TurningStorageArea_id}
                            Capacidad: ${matchingCapacity.HandlingCapacity_Cnt}`);*/

                        // Marcar el detalle como aprobado para el turno especifico.
                        this.radioUpdated(null, detail, 'A');
                        this.$set(this.mvm_detail, index, {
                            ...this.mvm_detail[index],
                            ReplicationError_desc: 'Hay capacidad disponible para el punto, dia, hora y almacen a turnar.'
                        });
                        this.$set(this.mvm_detail, index, {
                            ...this.mvm_detail[index],
                            ReplicationError: 'W'
                        });


                        // Preparar un filtro para insertar el turno siempre y cuando haya capacidad.
                        const filterSaveProposal = {
                            Details: [this.mvm_detail[index]], // Asegúrate de que Details sea un array
                            email: this.$store.state.ApiUser_EMail
                        };

                        // Iniciar llamado de endpoints para insertar el turno.
                        axios.post(this.api_tool_url + '/save_proposalTurnLineUpdate',filterSaveProposal, this.config)
                        .then(response => {
                          if(response.data.ResultRows.length >= 1)
                          {
                            this.$set(this.mvm_detail, index, {
                                ...this.mvm_detail[index],
                                ReplicationError_desc: 'Hay capacidad disponible (Aplicando cambios en el turno...).'
                            });
                            let data={ApiUser_id:sessionStorage.getItem('ApiUser_id'), token:sessionStorage.getItem('access_token'), ProposalTurnUpdate_id: this.mvm_detail[index].ProposalTurnUpdate_id}

                            axios.post(this.api_tool_url + '/ApplyChanges_modif', data, this.config)
                                .then(response => {
                                    if(response.data.ResultRows.length >= 1)
                                    {
                                      this.$set(this.mvm_detail, index, {
                                          ...this.mvm_detail[index],
                                          ReplicationError_desc: 'Hay capacidad disponible (Enviando mail a proveedor con los cambios...).'
                                      });

                                      axios.post(this.api_tool_url + '/send_proposalTurnUpdates', filterSaveProposal, this.config)
                                        .then(response => {
                                            if(response.data.ResultRows.length >= 1)
                                            {
                                              this.$set(this.mvm_detail, index, {
                                                  ...this.mvm_detail[index],
                                                  ReplicationError_desc: 'Hay capacidad disponible (Mails Enviados exitosamente...).'
                                              });
                                              
                                              setTimeout(this.close, 3000)

                                              this.$set(this.mvm_detail, index, {
                                                  ...this.mvm_detail[index],
                                                  ReplicationError_desc: 'Capacidad disponible. Turno aplicado correctamente.',
                                                  isCheckboxDisabled: true
                                                  
                                              });
                                            }
                                            else{
                                                this.$set(this.mvm_detail, index, {
                                                    ...this.mvm_detail[index],
                                                    ReplicationError_desc: 'No se pudo enviar mail en el turno automaticamente'
                                                });
                                            }
                                        })
                                        .catch(error => {
                                            this.$set(this.mvm_detail, index, {
                                                  ...this.mvm_detail[index],
                                                  ReplicationError_desc: 'Se producio un error en el cambio del turno automaticamente. Hay capacidad disponible.'
                                              });
                                        })
                                    }
                                    else{
                                        this.$set(this.mvm_detail, index, {
                                                  ...this.mvm_detail[index],
                                                  ReplicationError_desc: 'Hay capacidad disponible. No se pudieron aplicar los cambios en el turno automaticamente.'
                                              });
                                    }
                                })
                                .catch(error => {
                                    this.$set(this.mvm_detail, index, {
                                                  ...this.mvm_detail[index],
                                                  ReplicationError_desc: 'Hay capacidad disponible. No se pudieron aplicar los cambios en el turno automaticamente.'
                                              });
                                })
                          }
                          else{
                              this.$set(this.mvm_detail, index, {
                                                  ...this.mvm_detail[index],
                                                  ReplicationError_desc: 'Hay capacidad disponible. No se pudieron aplicar los cambios en el turno automaticamente.'
                                              });
                          }
                        })
                        .catch(error => {
                          this.$set(this.mvm_detail, index, {
                              ...this.mvm_detail[index],
                              ReplicationError_desc: 'Hay capacidad disponible. No se pudieron aplicar los cambios en el turno automaticamente.'
                          });
                        })

                        //this.mvm_detail[index].ReplicationError_desc = 'Hay capacidad disponible para el punto, dia, hora y almacen a turnar.'
                        //this.mvm_detail[index].ReplicationError = 'W'
                        return;
                    }
                    else
                    {
                        this.$set(this.mvm_detail, index, {
                            ...this.mvm_detail[index],
                            ReplicationError_desc: ''
                        });
                    }
                }
            } 
            catch (error) 
            {
                console.error('Error al obtener los turnos o capacidades:', error);
            }
          }
      },

      radioUpdated(e, item, value){
        const index = this.mvm_detail.indexOf(item)
        this.mvm_detail[index].RequestProposalStatus_Cd = value
      }, 

      checkAllRadios(value){
        this.mvm_detail = this.mvm_detail.map((detail) => ({ ...detail, RequestProposalStatus_Cd: value }))
        //console.log(this.mvm_detail)
      },

      getChipColor(status){
        if(status == 'ABIERTO'){
          return "#DBEAFE"
        }else if (status == 'REVISADO'){
          return "#D1FAE5"
        }else{
          return ""
        }
      },


      onexport () { // On Click Excel download button
        // export json to Worksheet of Excel
      
        const header_d_f = ['Propuesta Pedido id','OC','Punto','Fecha Turno','Fecha Cambio','Hora Cambio', 'Fecha Emisión', 'Fecha de cierre', 'Almacen', 'Bultos Pedidos', 'Pallets Pedidos', 'Indicador', 'Error', 'Error Desc', 'Estado'];
        const header_d = ['RequestProposal_id', 'VendorPurchaseOrder_Num', 'OpPoint_id', 'OrigCDay_id', 'CDay_id', 'CHour_id', 'RequestProposal_Dt',  'Closing_Dt', 'TurningStorageArea_id', 'RequestPack_Qty', 'RequestPallet_Qty', 'Type_ind', 'ReplicationError_Cd', 'ReplicationError_Desc', 'RequestProposalStatus_Cd'];
        var detalleWS = XLSX.utils.json_to_sheet(this.mvm_detail, {header: header_d}) 

        var range = XLSX.utils.decode_range(detalleWS['!ref']);
        for(var C = range.s.c; C <= range.e.c; ++C) {
          var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
          detalleWS[colum].v = header_d_f[C];
        }

        range.e['c'] = header_d_f.length - 1;
        detalleWS['!ref'] = XLSX.utils.encode_range(range);

        // A workbook is the name given to an Excel file
        var wb = XLSX.utils.book_new() // make Workbook of Excel

        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        // sheetAName is name of Worksheet
        XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
        
        var file='Detalle_Modificaciones_Propuesta_'+this.currentProposalId+'.xlsx';

        // export Excel file
        XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
      }
     }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/RequestProposalModif.vue